import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const PatientDetailsBiochemicalTestResultSelector = ({ classes, options, selectedValue, handleTestResultSelect }) => (
  <Autocomplete
    id="test-result-select"
    size="small"
    className={classes.muiInputs}
    options={options}
    value={selectedValue}
    onChange={handleTestResultSelect}
    getOptionLabel={option => option.label || ''}
    renderOption={(props, option) => <li {...props} key={option.testId}>{option.label}</li>}
    renderInput={(params) => <TextField {...params} label="Select a Test Result to Review" variant="outlined" size="small" />}
    isOptionEqualToValue={(option, value) => option.testId === value?.testId}
  />
);

export default PatientDetailsBiochemicalTestResultSelector;